import { render, staticRenderFns } from "./SetNewPasscode.vue?vue&type=template&id=310baa92&scoped=true&"
import script from "./SetNewPasscode.vue?vue&type=script&lang=js&"
export * from "./SetNewPasscode.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPasscode.vue?vue&type=style&index=0&id=310baa92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310baa92",
  null
  
)

export default component.exports